import React from 'react';

import { DateTime } from 'luxon';
import { useField } from 'formik';

import { FieldFormGroupProps } from '@shared/components/fields/field_form_group';
import { FormikFieldFormGroup } from '@shared/components/fields/formik/formik_field_form_group';

export function formatDateTimeForTimePickerInput(datetime: DateTime) {
  const hour = datetime.hour >= 10 ? `${datetime.hour}` : `0${datetime.hour}`;
  const minute = datetime.minute >= 10 ? `${datetime.minute}` : `0${datetime.minute}`;
  return `${hour}:${minute}`;
}

export function formatUTCTimeStringForTimePickerInput(timeString: string): string {
  // Try SQL parser first (handles “YYYY-MM-DD HH:mm:ss UTC”)
  let dt = DateTime.fromSQL(timeString, { zone: 'utc' });

  // Fallback to explicit format if fromSQL failed
  if (!dt.isValid) {
    dt = DateTime.fromFormat(timeString, "yyyy‑MM‑dd HH:mm:ss 'UTC'", { zone: 'utc' });
  }

  // Fallback to assuming ISO string
  if (!dt.isValid) {
    dt = DateTime.fromISO(timeString);
  }

  if (!dt.isValid) {
    return '';
  }

  // Format hours and minutes as two‐digit strings
  const hh = String(dt.hour).padStart(2, '0');
  const mm = String(dt.minute).padStart(2, '0');
  return `${hh}:${mm}`;
}

// The time should value should be a string in the format of hh:mm (e.g. "15:30")
export const FormikTimePickerFormGroup: React.FC<FieldFormGroupProps & { name: string }> = ({
  help,
  label,
  name,
  id,
}) => {
  const [{ value }, _, { setValue }] = useField(name);

  return (
    <FormikFieldFormGroup name={name} help={help} label={label} id={id}>
      <input
        id={id}
        type="time"
        className="form-control"
        value={value}
        onChange={(event) => setValue(event.target.value)}
      />
    </FormikFieldFormGroup>
  );
};
